/**
 * @file
 * Utilities to share between the service worker and the client. All functions
 * must be stateless and not assume an environment.
 */

export const urlBase64ToUint8Array = (base64String: string) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const getDeviceName = (userAgent: string | undefined) => {
  if (!userAgent) {
    return 'Browser';
  }
  // Taken from https://github.com/DamonOehlman/detect-browser, just taking
  // the parts we need.
  const uaRules: [string, RegExp][] = [
    ['Edge', /Edge\/([0-9._]+)/],
    ['iOS', /EdgiOS\/([0-9._]+)/],
    ['Edge', /EdgA?\/([0-9.]+)/],
    ['Chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9.]+)(:?\s|$)/],
    ['Firefox', /Firefox\/([0-9.]+)(?:\s|$)/],
    ['Opera', /Opera\/([0-9.]+)(?:\s|$)/],
    ['Opera', /OPR\/([0-9.]+)(:?\s|$)/],
    ['Android', /Android\s([0-9.]+)/],
    ['iOS', /Version\/([0-9._]+).*Mobile.*Safari.*/],
    ['Safari', /Version\/([0-9._]+).*Safari/],
    ['iOS', /AppleWebKit\/([0-9.]+).*Mobile/],
    ['iOS', /AppleWebKit\/([0-9.]+).*Gecko\)$/],
  ];

  const match = uaRules.find(uaRule => {
    const res = uaRule[1].exec(userAgent);
    return !!res;
  });

  return match ? match[0] : 'Browser';
};

export const getDeviceType = (userAgent: string): 'Desktop' | 'Mobile' => {
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return mobileRegex.test(userAgent) ? 'Mobile' : 'Desktop';
};
